import React from "react";
import "./tables.styles.scss";
import CheckLength from '../common/checkLength';

const quarters = ["Q1", "Q2", "Q3", "Q4"];

export default function SeasonCoutTable(props) {

  return (
    <table className='season-count-table'>

      <thead>
        <tr>
          <th className='tables-cell season-header-cell'>Years</th>
          {quarters.map((item,ind) => (
            <th className='tables-cell season-header-cell' key={ind} >{item}</th>
          ))
          }
        </tr>
      </thead>

      <tbody>

        {props.data ?
          props.data.map((item, index) => (

            <tr key={index} className='last-row'>
              <td className='tables-cell year-column'>{Object.keys(item)}</td>
              <td className='tables-cell'>{item[Object.keys(item)] ? CheckLength(item[Object.keys(item)].q1, "quater") + '%' : "NO"}</td>
              <td className='tables-cell'>{item[Object.keys(item)] ? CheckLength(item[Object.keys(item)].q2, "quater") + '%' : "NO"}</td>
              <td className='tables-cell'>{item[Object.keys(item)] ? CheckLength(item[Object.keys(item)].q3, "quater") + '%' : "NO"}</td>
              <td className='tables-cell'>{item[Object.keys(item)] ? CheckLength(item[Object.keys(item)].q4, "quater") + '%' : "NO"}</td>
            </tr>

          ))
          :
          null
        }

      </tbody>

    </table>
  )
}
